import ApiPermisos from './../../services/apiPermisos'

export default {
    namespaced: true,
    state: {
        loading: false,
        loading2: false,
        error:{},
        message:{},
        trainingInfo:{},
        training:{}
    },
    getters: {},
    mutations: {
        setLoading: (state, loading) => {
            state.loading = loading;
        },
        setLoading2: (state, loading2) => {
          state.loading2 = loading2;
      },
        setError:(state, error) => {
            state.error.message = error  
        },
        setMessage:(state, message) => {
            state.error = {}
            state.message = message  
        },
        setTrainigInfo:(state, trainingInfo) => {
            state.trainingInfo = trainingInfo.data
        },
        setTrainigInfoById:(state, training) => {
          state.training = training
        }
    },
    actions: {    
      // Guarda la selección
  
      //Consulta los cargos asociados al escenario getTrainingInfoById

    actGetTrainingInfo: async ({
        commit
      },data) => {
        try {
          commit('setLoading', true);
          let response = await ApiPermisos.getTrainingInfo(data);
          commit('setLoading', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setTrainigInfo', response);
          }
        } catch (error) {
          commit('setLoading', false);
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

      //Consulta los cargos asociados al escenario  saveTrainingInfo

      actGetTrainingInfoById: async ({
        commit
      },id) => {
        try {
          commit('setLoading2', true);
          let response = await ApiPermisos.getTrainingInfoById(id);
          commit('setLoading2', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setTrainigInfoById', response);
          }
        } catch (error) {
          commit('setLoading2', false);
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

      //Consulta los cargos asociados al escenario  

      actSaveTrainingInfo: async ({
        commit
      },data) => {
        try {
          commit('setLodataing2', true);
          let response = await ApiPermisos.saveTrainingInfo(data);
          commit('setLoading2', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setMessage', response);
          }
        } catch (error) {
          commit('setLoading2', false);
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },
    },
  }
  